import { addHours, addMinutes, isBefore, parseISO, set } from 'date-fns';
import { sortByDate } from '@components/hotSeat/utils';
import { compareHours } from '@utils/dateHelpers';
import { HOURS_COUNT, START_HOUR } from '@contexts/scheduler/constants';
import { Schedule } from '@root/globalTypes';
import { SchedulerSegment } from '@contexts/scheduler/types';

export const appendHours = (array: unknown[], date: Date) => array.map((_, i) => addHours(date, i));

export const getHours = (date: Date, hoursCount: number = HOURS_COUNT) =>
  appendHours([...new Array<undefined>(hoursCount)], date);

export const getFirstHour = (date: Date, dayStart: number = START_HOUR) =>
  set(date, { hours: dayStart, minutes: 0, seconds: 0 });

export const getLastHour = (hours: Date[][], segment: SchedulerSegment) => {
  const lastHour = hours[hours.length - 1];
  return addMinutes(lastHour[lastHour.length - 1], segment.length);
};

export const getDividedHours = (hours: Date[], segment: SchedulerSegment) =>
  hours.map((el) =>
    [...new Array<undefined>(segment.count)].map((_, i) => addMinutes(el, segment.length * i)),
  );

export const groupSchedules = (items: Schedule[]) => {
  const schedules = sortByDate(items, 'startsAt', 'asc');
  let newSchedules: Schedule[][] = [];
  let tmp: Schedule[] = [];
  const usedSchedulesIds: string[] = [];
  let prevEndsAt: Date | undefined;

  schedules.forEach((schedule) => {
    if (usedSchedulesIds.includes(schedule?.id || '')) return;
    const startsAt = parseISO(schedule?.startsAt || '');
    if (!prevEndsAt || isBefore(prevEndsAt, startsAt) || compareHours(prevEndsAt, startsAt)) {
      tmp.push(schedule);
    } else {
      if (tmp.length) newSchedules.push(tmp);
      newSchedules.push([schedule]);
      tmp = [];
    }
    usedSchedulesIds.push(schedule?.id || '');
    prevEndsAt = parseISO(schedule.endsAt);
  });

  if (tmp.length) newSchedules = [...newSchedules, tmp];

  return newSchedules;
};
